import React from 'react';
import { useSmartTranslations } from 'js/hooks/i18n';
import { ManagedPopup } from 'js/components/common/Popup';
import { WebContent } from 'js/components/system/WebContent';
import { useCombinedOnClose } from 'js/components/common/PopupManager';

import style from './CommonPopup.scss';

export const getOkButton = (onClick, text = 'playtech.mobile.system.popup.okButton') => [
    {
        text,
        onClick,
        className: style.btn
    }
];

export const CommonPopup = ({ id, content = '', articleId, onClose, btnTitle, buttons, ...props }) => {
    const t = useSmartTranslations();
    const combinedClosePopup = useCombinedOnClose(onClose);
    const popupButtons = buttons?.length ? buttons : getOkButton(combinedClosePopup, btnTitle);

    return (
        <ManagedPopup id={id} onClose={combinedClosePopup} buttons={popupButtons} {...props}>
            <WebContent content={t(content)} id={articleId} popupId={id} />
        </ManagedPopup>
    );
};
